
import Icon from '../Icon'
import Tooltip from '../Tooltip'
import { mapState } from 'vuex'

export default {
  name: 'OrderHeader',
  components: {
    Icon,
    Tooltip
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    topAction: {
      type: Object,
      default: () => {
        return {
          show: false,
          text: '',
          iconName: '',
          iconClasses: '',
          callback: () => { },
        }
      },
    },
    leftAction: {
      type: Object,
      default: () => {
        return {
          show: false,
          text: '',
          iconName: '',
          iconClasses: '',
          callback: () => { },
        }
      },
    },
    rightAction: {
      type: Object,
      default: () => {
        return {
          show: false,
          text: '',
          iconName: '',
          iconClasses: '',
          callback: () => { },
        }
      },
    },
    showHandoffMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['appInfo', 'cart']),
    canShowHandoffMode() {
      return this.appInfo?.checkout?.show_handoff_mode && this.showHandoffMode
    },
    checkoutTitle() {
      return this.canShowHandoffMode && this.cart?.handoff
        ? `Your ${this.cart.handoff} Order`
        : this.title
    }
  },
}
